export default function useCountryCode() {
  // not ideal, maybe improve later
  return (global.currentLocale || 'es_CL').split('_')[1]
}
